<template>
  <div :id="key" class="spark" role="button" @click="$emit('click')"></div>
</template>

<script>
import { v4 as uuid } from "uuid";
import { Spark } from "../../../shared/utils/spark";
import ontick_colors from "../../../shared/utils/ontick_colors";
import { mapGetters } from "vuex";

export default {
  props: {
    symbol: {
      type: String,
    },

    padding: {
      type: Number,
      default: 8,
    },

    width: {
      type: Number,
    },

    height: {
      type: Number,
    },

    // dataset: {
    //   type: Object,
    //   default: () => {
    //     let arr = [10000];

    //     for (let i = 1; i < 180; i++) {
    //       if (Math.random() <= 0.5) {
    //         arr.push(arr[i - 1] - Math.random() * 100);
    //       } else {
    //         arr.push(arr[i - 1] + Math.random() * 100);
    //       }
    //     }

    //     return {
    //       points: arr,
    //     };
    //   },
    // },
  },

  data() {
    return {
      key: uuid(),
    };
  },

  computed: {
    ...mapGetters({
      getSymbolSparkline: "bests/getSymbolSparkline",
    }),
    dataset() {
      return this.getSymbolSparkline(this.symbol).sparkline;
    },
    sparklineData() {
      return this.getSymbolSparkline(this.symbol);
    },
  },

  methods: {
    mountChart() {
      const { steel, green, orange, blue } = ontick_colors;
      const default_watermark_options = {
        show: true,
        single_color: false,
        color: steel[400],
        value: null,
        dashed: true,
        dash_array: "4",
      };
      const options = {
        container_id: this.key,
        width: this.width || document.getElementById(this.key).offsetWidth,
        height: this.height || document.getElementById(this.key).offsetHeight,
        padding: this.padding,
        watermark: { ...default_watermark_options, value: this.sparklineData.day_open },
        dataset: this.dataset,
        color: blue[600],
        positive_color: green[600],
        negative_color: orange[600],
        stroke_width: 2,
        stroke_linecap: "round",
        shadow: true,
      };
      // console.log(options);

      const spark = new Spark({ ...options });
      spark.Light();
    },
  },

  mounted() {
    this.mountChart();
  },
};
</script>

<style lang="scss" scoped>
.spark {
  @apply max-h-12 flex items-center justify-center w-[100px] hover:brightness-125 active:brightness-75 transition-all;
}
</style>
